import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryDescriptionInterface } from 'common/types/entities/BlogCategoryDescriptionInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogCategoryDescription(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogCategoryDescription,
      parentId,
      masterBlockId,
    ),
    fontSize: 22,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 12,
    textAlign: 'center',
  } as BlogCategoryDescriptionInterface
}
